import { ProblemDetailsError } from "@fxid/openapi-client";
export const FACEBOOK_ASID_INTERNAL_ERROR_MESSAGE = "An internal error happened when processing this request";
export const FACEBOOK_ACCOUNT_CREATION_CONFIRMATION_REQUIRED = "facebook_player_account_creation_confirmation_required";
async function getSignedPlayerOptions(player, existingAccountOnly = false) {
    const signedPlayer = await player.getSignedPlayerInfoAsync("fxid_auth");
    if (signedPlayer == null) {
        throw new Error("Failed to get signed player info");
    }
    const options = {
        PlayerId: signedPlayer.getPlayerID(),
        Signature: signedPlayer.getSignature()
    };
    if (existingAccountOnly) {
        options.ExistingAccountOnly = true;
    }
    return options;
}
export function isFacebookAsidInternalError(error) {
    if (typeof error !== "object" ||
        error === null ||
        !("code" in error) ||
        !("message" in error) ||
        typeof error.code !== "string" ||
        typeof error.message !== "string") {
        return false;
    }
    return (error.code.trim().toUpperCase() === "UNKNOWN" &&
        error.message.trim().toLowerCase() === FACEBOOK_ASID_INTERNAL_ERROR_MESSAGE.toLowerCase());
}
export async function buildFacebookInstantGamesAuthOptions(player, recovery, onEvent) {
    let signedAsid;
    try {
        signedAsid = await player.getSignedASIDAsync();
    }
    catch (error) {
        if (typeof error === "object" &&
            error !== null &&
            "code" in error &&
            error.code === "ASID_RETRIEVAL_BLOCKED") {
            return getSignedPlayerOptions(player);
        }
        if (isFacebookAsidInternalError(error) &&
            recovery.enabled &&
            recovery.protocolVersion >= 1) {
            onEvent?.("asid_internal_error_recovery_started");
            return getSignedPlayerOptions(player, true);
        }
        throw error;
    }
    if (signedAsid == null) {
        return getSignedPlayerOptions(player);
    }
    const asid = signedAsid.getASID();
    if (asid == null || asid.trim() === "") {
        return getSignedPlayerOptions(player);
    }
    const asidOptions = {
        ApplicationScopedId: asid,
        Signature: signedAsid.getSignature()
    };
    try {
        const signedPlayer = await player.getSignedPlayerInfoAsync("fxid_auth");
        if (signedPlayer == null) {
            onEvent?.("signed_player_unavailable_after_asid");
            return asidOptions;
        }
        return {
            ApplicationScopedId: asid,
            ApplicationScopedIdSignature: signedAsid.getSignature(),
            PlayerId: signedPlayer.getPlayerID(),
            Signature: signedPlayer.getSignature()
        };
    }
    catch {
        onEvent?.("signed_player_unavailable_after_asid");
        return asidOptions;
    }
}
export function isAccountCreationConfirmationRequired(error) {
    if (!(error instanceof ProblemDetailsError) || error.status !== 409) {
        return false;
    }
    const extensions = error.details.extensions;
    if (typeof extensions !== "object" ||
        extensions === null ||
        !("errors" in extensions) ||
        !Array.isArray(extensions.errors)) {
        return false;
    }
    return extensions.errors.some((item) => typeof item === "object" &&
        item !== null &&
        "code" in item &&
        item.code === FACEBOOK_ACCOUNT_CREATION_CONFIRMATION_REQUIRED);
}
export async function authenticateFacebookInstantGamesWithConfirmation(options, authenticate, confirmCreation) {
    try {
        await authenticate(options);
        return true;
    }
    catch (error) {
        if (options.ExistingAccountOnly !== true || !isAccountCreationConfirmationRequired(error)) {
            throw error;
        }
        return confirmCreation(async () => {
            const retryOptions = { ...options };
            delete retryOptions.ExistingAccountOnly;
            await authenticate(retryOptions);
        });
    }
}
